import { gql } from 'urql';

export const CHOFER_BASE_FIELDS = gql`
  fragment ChoferBase on Chofer {
    id
    apellido
    nombre
    apodo
    nombreCompleto
    tipoDocumento
    nroDocumento
    cuilCuit
    telefonoMovil
    telefonoAlternativo
    email
    empresaId
    sucursalId
    empresaNombre
    sucursalNombre
    estado
    licenciaClase
    licenciaVencimiento
    licenciaEmision
    licenciaRestricciones
    fechaAlta
    createdAt
    updatedAt
    deletedAt
  }
`;

export const CHOFER_EXTENDED_FIELDS = gql`
  fragment ChoferExtended on Chofer {
    ...ChoferBase
    direccionCalle
    direccionNumero
    direccionPiso
    direccionDepto
    localidad
    provincia
    pais
    fechaNacimiento
    genero
    legajo
    docDniFrenteUrl
    docDniDorsoUrl
    docLicenciaUrl
    docAntecedentesUrl
    docARTUrl
    docOtros
    aptoPsicofisico
    aptoFecha
    observaciones
    createdBy
    updatedBy
  }
  ${CHOFER_BASE_FIELDS}
`;

export const CHOFERES_LIST = gql`
  query ChoferesList($page: Int, $pageSize: Int, $filter: ChoferFilter, $order: ChoferOrder) {
    choferes(page: $page, pageSize: $pageSize, filter: $filter, order: $order) {
      total
      pageInfo {
        page
        pageSize
        hasNext
        hasPrev
      }
      rows {
        ...ChoferBase
      }
    }
  }
  ${CHOFER_BASE_FIELDS}
`;

export const CHOFER_BY_ID = gql`
  query ChoferById($id: ID!) {
    chofer(id: $id) {
      ...ChoferExtended
    }
  }
  ${CHOFER_EXTENDED_FIELDS}
`;

export const CREATE_CHOFER = gql`
  mutation CreateChofer($input: ChoferInput!) {
    createChofer(input: $input) {
      ...ChoferExtended
    }
  }
  ${CHOFER_EXTENDED_FIELDS}
`;

export const UPDATE_CHOFER = gql`
  mutation UpdateChofer($id: ID!, $input: ChoferInput!) {
    updateChofer(id: $id, input: $input) {
      ...ChoferExtended
    }
  }
  ${CHOFER_EXTENDED_FIELDS}
`;

export const DELETE_CHOFER_SOFT = gql`
  mutation DeleteChoferSoft($id: ID!) {
    deleteChoferSoft(id: $id)
  }
`;

export const RESTORE_CHOFER = gql`
  mutation RestoreChofer($id: ID!) {
    restoreChofer(id: $id) {
      ...ChoferExtended
    }
  }
  ${CHOFER_EXTENDED_FIELDS}
`;

export const BULK_ACTION_CHOFERES = gql`
  mutation BulkActionChoferes($ids: [ID!]!, $action: ChoferBulkAction!) {
    bulkActionChoferes(ids: $ids, action: $action) {
      processed
      success
      failed
      errors
    }
  }
`;

export const UPSERT_DOCUMENT_LINKS = gql`
  mutation UpsertChoferDocs($id: ID!, $docs: [DocLinkInput!]!) {
    upsertChoferDocumentLinks(id: $id, docs: $docs) {
      ...ChoferExtended
    }
  }
  ${CHOFER_EXTENDED_FIELDS}
`;
